import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPaperclip32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconPaperclip32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M11.106 7.12C10.444 7.83 10 8.938 10 10.5V21c0 3.009 2.46 6 6 6 1.934 0 3.697-.468 4.952-1.421C22.167 24.656 23 23.209 23 21V10.001L24 10h1v11c0 2.79-1.091 4.844-2.838 6.171C20.454 28.468 18.218 29 16 29c-4.763 0-8-4.009-8-8V10.5c0-1.938.556-3.58 1.644-4.745C10.738 4.583 12.27 4 14 4s3.262.583 4.356 1.755C19.444 6.921 20 8.562 20 10.5V21c0 .977-.33 1.87-.98 2.52s-1.543.98-2.52.98c-2.134 0-3.454-1.765-3.5-3.473-.017-.65-.017-3.421-.013-6.002l.008-3.487.004-1.12v-.414L13 9.998v-.001l.994.003L13 9.997a1 1 0 1 1 2 .007L14 10l1 .004v.109l-.001.311-.004 1.12-.008 3.484c-.004 2.603-.004 5.332.013 5.945.021.819.634 1.527 1.5 1.527.523 0 .88-.17 1.105-.395.225-.224.395-.582.395-1.105V10.5c0-1.562-.444-2.67-1.106-3.38C16.238 6.417 15.27 6 14 6s-2.238.417-2.894 1.12M24 9a1 1 0 0 1 1 1h-2a1 1 0 0 1 1-1"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPaperclip32);
